<template>
  <div class="agent-settings">
    <div v-if="agent">
      <div>
        <h2 class="ut-mb-6">Manage your preferences and account settings</h2>

        <accordian>
          <accordian-item
            :name="sections.Notifications.name"
            :isOpen="sections.Notifications.isOpen"
            @click-header="headerClicked">
            <h3 slot="title">{{ sections.Notifications.title }}</h3>
            <template slot="body" class="ut-pl-0">
              <div class="ut-flex">
                <label class="switch">
                  <input @click="toggleAgentDigest" v-model="hasagentdigest" type="checkbox">
                  <span class="slider round"></span>
                </label>
                <p class="ut-ml-1">Subscribe to my weekly Agent Digest,
                  which shows the details of all leads I have with OpenAgent.</p>
              </div>
            </template>
          </accordian-item>

          <accordian-item
            v-if="hasPortalAccount"
            :name="sections.Password.name"
            :isOpen="sections.Password.isOpen"
            @click-header="headerClicked">
            <h3 slot="title">{{ sections.Password.title }}</h3>
            <template slot="body">
              <account-password-update />
            </template>
          </accordian-item>
        </accordian>

      </div>
    </div>
    <loading-spinner v-else />
  </div>
</template>

<script>

import { mapState, mapMutations, mapGetters } from 'vuex';
import AccountPasswordUpdate from '@/components/Account/AccountPasswordUpdate.vue';
import Accordian from '@/components/Accordions/Accordian.vue';
import AccordianItem from '@/components/Accordions/AccordianItem.vue';

export default {
  name: 'AgentSettings',
  components: {
    AccountPasswordUpdate,
    Accordian,
    AccordianItem,
  },
  data() {
    return {
      hasagentdigest: false,
      sections: {
        Notifications: {
          name: 'Notifications',
          title: 'Notifications settings',
          isOpen: false,
          userInput: null,
        },
        Password: {
          name: 'Password',
          title: 'Change password',
          isOpen: false,
          userInput: null,
        },
      },
    };
  },
  created() {
    this.hasagentdigest = this.agent.hasagentdigest;
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    ...mapGetters('userStore', [
      'hasPortalAccount',
    ]),
  },
  methods: {
    ...mapMutations('agentStore', {
      setAgent: 'setAgent',
    }),
    headerClicked(values) {
      this.displayDefault = false;
      if (values.name) {
        if (values.state === false) {
          this.sections[values.name].isOpen = true;
          this.sections[values.name].userInput = 'open';
        } else {
          this.sections[values.name].isOpen = false;
          this.sections[values.name].userInput = 'close';
        }
      }
    },
    toggleAgentDigest() {
      this.$apiServices.oa.agent.toggleAgentDigest(this.agent.key)
        .then((agentData) => {
          this.setAgent(agentData);
        });
    },

  },
};

</script>

<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 12px;
  @apply ut-mx-3;

  &:hover {
    @apply ut-text-green-400;
  }
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .slider {
    background-color: #99E0AD;
  }

  &:checked + .slider:before {
    transform: translateX(12px);
    @apply ut-bg-green-400 ut-border ut-border-green-400;
  }


}


.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #C4C3C0;
  transition: .4s;
  border-radius: 6px;

  &:hover {
      &:before {
        box-shadow: 0px 0px 0px 10px rgba(37, 186, 104, 0.2);
      }
    }

  &:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    bottom: -4px;
    background-color: #ffffff;
    border: solid 1px #989690;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;


  }


}


</style>
